import { resolveAdminUserFieldStyle } from './adminUserFieldStyle';

/**
 * WhatsApp, LinkedIn, and gender — Additional Fields only (not Basic info).
 */
export default function AdminUserAdditionalContactFields({
  formData,
  onChange,
  getFieldStyle,
}) {
  const s = (value, fieldName) =>
    resolveAdminUserFieldStyle(getFieldStyle, value, false, fieldName);

  return (
    <div className="mb-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          type="text"
          name="whatsapp"
          placeholder="WhatsApp Number"
          value={formData.whatsapp || ''}
          onChange={onChange}
          className="px-4 py-3 theme-input rounded-lg theme-focus"
          style={s(formData.whatsapp, 'whatsapp')}
        />
        <input
          type="text"
          name="linkedIn"
          placeholder="LinkedIn Profile URL"
          value={formData.linkedIn || ''}
          onChange={onChange}
          className="px-4 py-3 theme-input rounded-lg theme-focus"
          style={s(formData.linkedIn, 'linkedIn')}
        />
      </div>
      <div>
        <label className="block font-semibold mb-2" style={{ color: 'var(--color-text)' }}>
          Gender:
        </label>
        <div className="flex flex-wrap gap-4">
          {['Male', 'Female', 'Other'].map((value) => (
            <label key={value} className="flex items-center">
              <input
                type="radio"
                name="gender"
                value={value}
                checked={formData.gender === value}
                onChange={onChange}
                className="mr-2"
              />
              <span style={{ color: 'var(--color-text)' }}>{value}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}
